module.exports = __webpack_public_path__ + "static/media/zola-logomark-cloud.d8350ad8.svg";